import React from 'react';
import { CHECKOUT_URL } from '../data/atlas';
const blocks = [{
  heading: '😰 STOP DROWNING IN ENDLESS TEXTBOOKS',
  body: 'Textbooks give you information. But information still needs to be understood, connected and remembered. You need visual maps, clear classifications, labeled components, side-by-side comparisons, organized workflows and resources you can actually use to review.',
  kicker: 'Open the system. See the concept. Understand the connection. Review.'
}, {
  heading: '⏱️ LESS SEARCHING. CLEARER STUDY. FASTER REVISION.',
  body: 'Need to review Complete Dentures? It’s there. Need to identify an RPD or implant component? It’s there. Need to compare materials, understand occlusion or review a prosthodontic workflow? It’s already organized.',
  kicker: 'One visual system for the Prosthodontics you need to study.'
}];
export function ProblemSection() {
  return <section className="border-y-4 border-ice bg-white px-4 py-6 sm:py-8" data-id="element-135" data-mp="1k3r3nv496tlc">
      <div className="mx-auto max-w-3xl" data-id="element-136" data-mp="jddfih4jgszr">
        <h2 className="text-center text-2xl leading-none text-navy sm:text-3xl" data-id="element-137" data-mp="jeoi4dm8zupa">
          What if Prosthodontics was easier to visualize?
        </h2>
        <p className="mt-2 text-center text-sm font-medium leading-snug text-slate2 sm:text-base" data-id="element-138" data-mp="se1txcxugvd6">
          You already study the terminology, classifications and concepts. The problem is
          connecting everything together. Which component is which? What’s the difference
          between two similar concepts? How does each stage connect? Which materials belong
          where? How do you organize everything before an exam?{' '}
          <strong className="font-extrabold text-navy" data-id="element-139" data-mp="1c33t8p29dsvc">
            PROSTHODONTICS VISUAL ATLAS™
          </strong>{' '}
          gives you one organized visual system to understand, connect and review
          Prosthodontics without constantly getting lost in pages of disconnected
          information.
        </p>

        <div className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-140" data-mp="3hv0u4ed2cyby">
          {blocks.map(block => <a key={block.heading} href={CHECKOUT_URL} className="flex flex-col rounded-lg border-l-4 border-teal bg-ice/50 p-4 transition-colors duration-150 hover:bg-ice" data-id="element-141" data-mp="p0it7l7dtrne">
              <h3 className="text-lg leading-tight text-navy" data-id="element-142" data-mp="tzd8id654y2r">{block.heading}</h3>
              <p className="mt-1.5 text-sm font-medium leading-snug text-slate2" data-id="element-143" data-mp="u1g9ttcqudms">
                {block.body}
              </p>
              <p className="mt-auto pt-2 text-sm font-extrabold text-teal" data-id="element-144" data-mp="130bcwwkhr7lv">
                {block.kicker}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}